//
import { required } from "@/services/validations"
import ProductModel from "@/models/Warehouse/WhProduct"
import UserModel from "@/models/General/GUser"
import WarehouseModel from "@/models/Warehouse/WhWarehouse"

//
import ProductFilters from "@/views/Warehouse/WhProduct/list/filters"
import ProductHeaders from "@/views/Warehouse/WhProduct/list/headers"

//
import StockAdjustDetailHeaders from "./headers"

//
export default {

    /**
     * 
     */
    dialog: [
        {
            name: "upc_codes",
            type: "text-field",
            flex: {
                sm6: true,
            },
            props: {
                label: "Código(s) UPC",
                readonly: true,
            },
        },
        {
            name: "internal_code",
            type: "text-field",
            flex: {
                sm6: true,
            },
            props: {
                label: "Código interno",
                readonly: true,
            },
        },
        {
            name: "name",
            type: "text-field",
            flex: {
                sm6: true,
            },
            props: {
                label: "Nombre",
                readonly: true,
            },
        },
        {
            name: "quantity",
            type: "text-field",
            flex: {
                sm6: true,
            },
            props: {
                name: "quantity-dialog-input",
                label: "Cantidad encontrada",
                type: "number",
            },
        },
    ],

    /**
     * 
     */
    take: ({ g_branch_office_id }) => [
        {
            name: "g_warehouseman_user_id",
            type: "autocomplete-model",
            flex: {
                sm6: true,
                lg3: true,
            },
            props: {
                chips: true,
                itemText: "full_name",
                itemValue: "id",
                label: "Responsable",
                loadingText: "Cargando empleados...",
                model: UserModel,
                noDataText: "Sin empleados.",
                noObject: true,
                readonly: true,
                rules: [ required ],
            },
        },
        {
            name: "wh_warehouse_id",
            type: "autocomplete-model",
            flex: {
                sm6: true,
                lg3: true,
            },
            props: {
                chips: true,
                itemText: "name",
                itemValue: "id",
                label: "Bodega",
                loadingText: "Cargando bodegas...",
                model: WarehouseModel,
                noDataText: "Sin bodegas.",
                noObject: true,
                paramFilter: {
                    g_branch_office_id,
                },
                readonly: true,
                rules: [ required ],
            },
        },
        {
            name: "created_at",
            type: "date-field",
            flex: {
                sm6: true,
                lg3: true,
            },
            props: {
                label: "Creado",
                pickerProps: {
                    readonly: true,
                },
            },
        },
        {
            name: "updated_at",
            type: "date-field",
            flex: {
                sm6: true,
                lg3: true,
            },
            props: {
                label: "Modificado",
                pickerProps: {
                    readonly: true,
                },
            },
        },
        {
            name: "wh_selected_products",
            type: "table-field",
            flex: {
                "pt-0": true,
                "xs12": true,
                "d-grid": true,
            },
            props: {
                checkable: true,
                class: "v-card elevation-2 mb-4",
                headers: StockAdjustDetailHeaders,
                noActions: true,
                noDataText: "Sin productos.",
                noFilter: true,
                noExport: true,
                noHelper: true,
                noPagination: true,
                noSearch: true,
                label: "Items",
                rowsPerPage: 50,
                rules: [ required ],
                showNativePagination: true,
                toolbarTitle: "Lista de productos incluidos en el inventario",
                toolbarColor: "primary",
                toolbarDark: true,
                toolbarDense: true,
            },
            slots: {
                items: 'table-items',
            }
        },
        {
            name: "description",
            type: "textarea",
            flex: {
                xs12: true,
            },
            props: {
                label: "Descripción",
                rules: [ required ],
            },
        },
    ],

    /**
     * 
     */
}